import { TemplateWithFieldsContext } from "@/contexts/templatesWithFields";
import { useContext } from "react";

export const useTemplateWithFields = () => {
  const context = useContext(TemplateWithFieldsContext);
  if (!context) {
    throw new Error("useTemplateWithFields must be used within a TemplateProvider");
  }

  return context;
};
